import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { passengerThemeV2 } from '@mopla/mui';

import { MplButton } from '../../atoms/MplButton/MplButton';

// This note follows the V2 design tokens from Figma (warning/light bg,
// warning/main icon, primary text), but the profile screen still runs on the V1
// passenger theme. V1 already provides the correct type ramp (b2 / bu1-m ===
// Figma B2 / BU1-M), so we keep the ambient theme's typography and only pull the
// colours from the V2 palette here.
const { warning, primary } = passengerThemeV2.palette;

export const NameChangeNoteRoot = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	marginBottom: '24px',
});

export const NoteBox = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '12px',
	borderRadius: '8px',
	backgroundColor: warning.light,
});

export const NoteIcon = styled('div')({
	flexShrink: 0,
	display: 'flex',
	color: warning.main,
});

// Figma: RPA/BODY/B2
export const NoteText = styled(Typography)(({ theme }) => ({
	...theme.typography.b2,
	flex: '1 1 0',
	minWidth: 0,
	wordBreak: 'break-word',
	color: primary.main,
}));

// Figma: RPA/BUTTON/BU1-M
export const SupportButton = styled(MplButton)(({ theme }) => ({
	...theme.typography['bu1-m'],
	alignSelf: 'center',
	marginTop: '4px',
	color: primary.main,

	// The shared ExternalLinkIcon is a fixed 12x13; Figma draws it at 24px.
	// Scale it up here (aspect preserved) so it reads closer to the design
	// without touching the icon used elsewhere.
	'& .MuiButton-endIcon svg': {
		width: '20px',
		height: 'auto',
	},
}));
